export default "https://cdn-static.gokick.com/assets/6706629b3df14a4b3713b9aca1ff59a1c44b8347/images/sleep-blueberry.3ee2bf0b929baac3dd5c59083edb83bb.png";